




















































































































































































import 'reflect-metadata'
import { Component, Vue, Watch } from 'vue-property-decorator'
import DropDownProductType from "@/components/common/combobox/DropDownProductType.vue"
import DropDownProject from "@/components/common/combobox/DropDownProjectMultiple.vue"
import DropDownManageUnit from "@/components/common/combobox/DropDownManageUnitMulitiple.vue"
import DatePickerFromTo from "@/components/common/date-picker/DatePickerFromTo.vue"
import DropDownFixData from "@/components/common/combobox/DropDownFixData.vue"
import Notification from "@/components/common/notification/Notification.vue"
import DataTableTrackingTransfer from "@/components/report/datatable/DataTableTrackingTransfer.vue"
import BreadcrumbsPath from "@/components/common/breadcrumbs/BreadcrumbsPath.vue"
import { ProjectApi, UnitApi, ReportApi, AuthenticateApi, PlanningTransferApi } from '@/api'
import { ExportExcel } from '@/resource/report/TrackingTransferExcel'
import { namespace } from 'vuex-class'

const Auth = namespace('authentication')

@Component({
    components: {
        DropDownProductType,
        DropDownProject,
        DropDownManageUnit,
        DatePickerFromTo,
        DropDownFixData,
        DataTableTrackingTransfer,
        Notification,
        BreadcrumbsPath
    }
})
export default class TrackingTransfer extends Vue { 
    breadcrumbs = [
        { text: 'Report' },
        { text: 'TrackingTransfer' }
    ]

    @Auth.State('auth') auth!: any

    panel = 0
    loading = false
    tableShow = false
    jsonData = {
        projectId: [] as string[],
        projectName: [] as string[],
        productType: "" as string,
        unitSelectType: "unitAll" as string,
        unitSelected: [] as any,
        unitFrom: "" as string,
        unitTo: "" as string,
        statusSold: [] as string[],
        transferStatusId: "" as string,
        statusDelivery: [] as string[],
        bookingDateFrom: "" as string,
        bookingDateTo: "" as string,
        contractDateFrom: "" as string,
        contractDateTo: "" as string,
        contractPmtAmtDateFrom: "" as string,
        contractPmtAmtDateTo: "" as string,
    } as any

    projectLists = [] as any
    unitLists = [] as any[]

    transferItemData = [
		{ id: 1 , name: 'โอนแล้ว', value: 1 },
		{ id: 2 , name: 'ยังไม่โอน', value: 0 },
	] as any
    
    @Watch("jsonData.productType")
    async onProductTypeChange(val: string, oldVal: string) {
        this.loading = true
        if (val !== "") {
            const projectLists: any = await ProjectApi.GetProjectLists()
            if (val != "0") this.projectLists = projectLists.filter((x: any) => x.productId == val)
            if (val == "0") this.projectLists = projectLists
        } else {
            this.projectLists = []
        }
        this.loading = false
    }

    @Watch("jsonData.projectId")
    async onProjectIdChange(val: any[], oldVal: string) {
        this.loading = true
        if (val === undefined) {
            this.openNotification("กรุณากรอกชื่อโครงการให้ถูกต้อง", "warning")
            this.loading = false
            return 
        }
        if (val.length === 1) {
            this.unitLists = await UnitApi.GetUnitListsByProjectId(val[0])
        } else {
            this.unitLists = []
        }
        this.loading = false
    }

    created () {
		this.startup()
	}

    async startup () {
        this.loading = true

        const getUserInfo = await AuthenticateApi.GetUserInfo()
            const hasMatchingPermission = getUserInfo?.permission.filter((filter) => filter.profileCode === "TFP-05" );

            if (hasMatchingPermission && hasMatchingPermission?.length <= 0) {
                localStorage.clear()
                window.location.reload()
            }
        this.loading = false
    }

    async loadTrackingTransferLists () {
        try {
            this.jsonData.transferStatusId = `${this.jsonData.transferStatusId}`
            const trackingTransferLists = await ReportApi.GetTrackingTransfer(this.jsonData)
            return trackingTransferLists
        } catch (error) {
            this.openNotification("ไม่สามารถโหลดข้อมูลได้ กรุณาลองใหม่", "warning")
            this.loading = false
            return
        }
    }

    async btnSearch () {
        if (this.validateSearch()) return

        this.loading = true
        this.jsonData.transferStatusId = `${this.jsonData.transferStatusId}`
        const trackingTransferLists = await this.loadTrackingTransferLists()

        let projectNames = this.projectLists
                .filter((project:any) => this.jsonData.projectId.includes(String(project.id)))
                .map((project:any) => project.name);
            this.jsonData.projectName = projectNames
        const logModel = {
                application_name: "Transfer_Planning",
                feature: "btnSearch Data Found : " + trackingTransferLists.length.toString() + " Records",
                page: "TrackingTransfer",
                json_data: JSON.stringify(this.jsonData),
                created_by: this.auth.username,
                };

            PlanningTransferApi.addLog(logModel)

        if (trackingTransferLists.length <= 0 ) {
            this.openNotification("ไม่มีข้อมูลยูนิต", "warning")
            this.tableShow = false
            this.loading = false
            return
        }
        this.tableShow = true
        const refDataTableReport = this.$refs.refDataTableTrackingTransfer as DataTableTrackingTransfer
        refDataTableReport.loadTableData(trackingTransferLists)
        this.loading = false
    }  
    
    async btnExportExcel () {
        if (this.validateSearch()) return 

        this.loading = true
        const trackingTransferLists = await this.loadTrackingTransferLists()

        let projectNames = this.projectLists
                .filter((project:any) => this.jsonData.projectId.includes(String(project.id)))
                .map((project:any) => project.name);
            this.jsonData.projectName = projectNames

        const logModel = {
                application_name: "Transfer_Planning",
                feature: "btnExportExcel Data Export : " + trackingTransferLists.length.toString() + " Records",
                page: "TrackingTransfer",
                json_data: JSON.stringify(this.jsonData),
                created_by: this.auth.username,
                };

            PlanningTransferApi.addLog(logModel)

        await ExportExcel(trackingTransferLists)
        this.openNotification('Export Excel สำเร็จ', 'success') 
        this.loading = false
    }

    async changeState (key: string, value: string) {
        this.jsonData[key] = value
    }

    validateSearch () {
        if (this.jsonData.projectId.length === 0) {
            this.openNotification("กรุณาเลือกโครงการ", "warning")
            return true
        }
    }

    notifcation (text: string) {
        const child = this.$refs.snackbar as any
        child.show(text)
    }

    openNotification (text: string, status: string) {
        const child = this.$refs.refNotifcation as any
        child.openNotification(text, status)
    }

}
